import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';
import { header } from '../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	actionButtons: {
		display: 'flex',
		gap: 12,
		justifyContent: 'center',
		marginTop: 24,
	},
	breakdown: {
		borderBottom: '2px solid #858585',
		marginBottom: 16,
		paddingBottom: 16,
	},
	buttonRow: {
		display: 'flex',
		gap: 12,
		justifyContent: 'center',
		marginTop: THEME.spacing.lg,
	},
	chargifyLink: {
		':hover': {
			background: THEME.colors.hover.main,
		},
		background: THEME.colors.primary.main,
		borderRadius: THEME.common.borderRadius,
		color: THEME.colors.primary.contrastText,
		padding: `${THEME.spacing.sm}px ${THEME.spacing.lg}px`,
		textDecoration: 'none',
		transition: 'background 0.2s',
	},
	checkboxGrid: {
		columnGap: '16px',
		display: 'grid',
		gridTemplateColumns: 'repeat(2, 1fr)',
		marginTop: '4px',
		rowGap: '8px',
	},
	checkboxLabel: {
		alignItems: 'center',
		color: header,
		cursor: 'pointer',
		display: 'flex',
		fontSize: 14,
		gap: 8,
	},
	container: {
		display: 'flex',
		flexDirection: 'column',
		overflow: 'hidden',
		padding: 24,
	},
	formGroup: {
		display: 'flex',
		flexDirection: 'column',
		marginBottom: 16,
	},
	formSection: {
		background: '#fff',
		border: '1px solid #D3DBDE',
		borderRadius: 8,
		boxShadow: '0 0 6px 0 rgba(139,139,139,0.30)',
		flex: '0 0 400px',
		maxHeight: '100%',
		overflowY: 'auto',
		padding: 24,
	},
	input: {
		border: '1px solid #D3DBDE',
		borderRadius: 4,
		fontSize: 14,
		padding: '8px 12px',
	},
	label: {
		color: header,
		fontSize: 14,
		fontWeight: 'bold',
		marginBottom: 8,
	},
	layout: {
		display: 'flex',
		flex: 1,
		gap: 24,
		minHeight: 0,
		overflow: 'hidden',
	},
	loadingContainer: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		gap: 16,
		justifyContent: 'center',
		padding: 48,
	},
	placeholder: {
		color: '#858585',
		fontSize: 16,
		textAlign: 'center',
	},
	resultLabel: {
		color: header,
		fontSize: 14,
	},
	resultRow: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
		padding: '8px 0',
	},
	resultValue: {
		color: header,
		fontSize: 14,
		fontWeight: 'bold',
	},
	monthlyNote: {
		color: '#6c757d',
		fontSize: 12,
		fontWeight: 'normal',
		marginRight: 4,
	},
	resultsSection: {
		background: '#fff',
		border: '1px solid #D3DBDE',
		borderRadius: 8,
		boxShadow: '0 0 6px 0 rgba(139,139,139,0.30)',
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		maxHeight: '100%',
		overflow: 'hidden',
	},
	resultsContent: {
		flex: 1,
		overflowY: 'auto',
		padding: 24,
	},
	select: {
		border: '1px solid #D3DBDE',
		borderRadius: 4,
		fontSize: 14,
		padding: '8px 12px',
	},
	spinnerContainer: {
		alignItems: 'center',
		display: 'flex',
		height: '100%',
		justifyContent: 'center',
	},
	summaryCard: {
		background: '#f8f9fa',
		border: '1px solid #D3DBDE',
		borderRadius: 8,
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		fontSize: 14,
		gap: 8,
		padding: 16,
	},
	splitBillingNote: {
		background: '#d4edda',
		border: '1px solid #c3e6cb',
		borderRadius: 8,
		color: '#155724',
		fontSize: 13,
		fontWeight: 600,
		marginTop: 12,
		padding: 12,
		textAlign: 'center',
	},
	summaryRow: {
		display: 'flex',
		gap: 16,
		marginBottom: 16,
	},
	noMatchModal: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.lg,
		padding: THEME.spacing.xxl,
		textAlign: 'center',
	},
	noMatchTitle: {
		color: THEME.colors.text.main,
		fontWeight: THEME.typography.fontWeights.bold,
		margin: 0,
	},
	noMatchMessage: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.md,
		lineHeight: 1.5,
		margin: 0,
	},
	noMatchLink: {
		':hover': {
			textDecoration: 'underline',
		},
		color: THEME.colors.primary.main,
		fontSize: THEME.typography.fontSizes.md,
		textDecoration: 'none',
	},
	publicPaymentLink: {
		':hover': {
			color: THEME.colors.primary.main,
			textDecoration: 'underline',
		},
		color: THEME.colors.text.light,
		display: 'block',
		fontSize: THEME.typography.fontSizes.sm,
		marginTop: THEME.spacing.sm,
		textAlign: 'center',
		textDecoration: 'none',
	},
});
